import UncontrolledPopover from 'components/SafeUncontrolledPopover';
import { FC, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'reactstrap';
import { Objective } from '../../utils/models/Objective';

interface Props {
  isEditable?: boolean;
  canAddChild?: boolean;
  setShowChildren?: (boolean) => void;
  addChild: (Objective) => void;
  value: Objective;
  setValue: (any) => void;
}

const ObjectiveItemAddControls: FC<Props> = ({
  isEditable,
  canAddChild = true,
  setShowChildren,
  addChild,
  value,
  setValue,
}) => {
  const { formatMessage } = useIntl();
  const addButtonRef = useRef<HTMLButtonElement>(null);

  // No objective type is valid under this parent, so creating a child would
  // only be rejected by the backend.
  if (!isEditable || !canAddChild) return null;

  return (
    <>
      <Button
        size="sm"
        color="secondary"
        id={`add-child-button-${value.key}`}
        aria-label={formatMessage({
          id: 'app.views.person.personal_objective_item.add_child.button.aria_label',
          defaultMessage: 'Add subobjective button',
        })}
        outline
        onClick={() => addChild({ value, setValue, setShowChildren })}
        innerRef={addButtonRef}
      >
        <i className="fe fe-plus" />
      </Button>
      <UncontrolledPopover
        placement="top"
        trigger="hover"
        target={addButtonRef}
      >
        <FormattedMessage
          id="app.views.person.personal_objective_item.add_child"
          defaultMessage="Add a subobjective"
        />
      </UncontrolledPopover>
    </>
  );
};

export default ObjectiveItemAddControls;
